<section class="main">
    <div class="table-title" [class.tuning-drilldown-title]="!!fileService.tuningDrilldown()">
        <div class="head-button">
            <button class="r-btn" (click)="onRefreshTable()">
                <i class="icon bi bi-arrow-clockwise"></i>
            </button>
        </div>
        <div class="act-search-bar" *ngIf="!fileService.tuningDrilldown()">
            <app-search-bar
                    (searchValue)="onSearchInput($event)"
                    [value]="'Client Number'"
            ></app-search-bar>
            <div class="filtering-buttons">
                <button type="button" class="filter-trigger" (click)="openAdvancedSearchSettings()"
                        [class.is-active]="fileService.openAdvanceSettings() || filterCount() > 0"
                        [attr.aria-expanded]="fileService.openAdvanceSettings()"
                        [attr.aria-label]="filterCount() > 0 ? 'Filters, ' + filterCount() + ' active' : 'Filters'">
                    <i class="bi bi-funnel" aria-hidden="true"></i>
                    <span>Filters</span>
                    @if (filterCount() > 0) {
                        <span class="count-filter" aria-hidden="true">{{ filterCount() }}</span>
                    }
                </button>
            </div>
        </div>
        <div class="tuning-drilldown-banner" *ngIf="fileService.tuningDrilldown() as filter">
            <span>Imports for <strong>{{ filter.tuningNames.join(' + ') }}</strong></span>
            <button type="button" (click)="clearTuningFilter()">Clear tuning filter</button>
        </div>
    </div>

    @if (fileService.openAdvanceSettings()) {
        <div>
            <app-file-service-filters
                    [displayedColumns]="fileService.displayedColumns()"
                    (fileServiceFilterClosed)="onAdvancedSettingClosed($event)"
                    (fileServiceSelectedFilters)="selectFilters($event)"
                    (filterCount)="updateFilterCount($event)"
            ></app-file-service-filters>
        </div>
    }
    @if (isInitialLoad()) {
        <div>
            <app-skeleton-table></app-skeleton-table>
        </div>
    } @else {
        @if (fileService.fileServiceTableIsLoading()) {
            <div class="spinner-container">
                <mat-spinner diameter="50"></mat-spinner>
            </div>
        } @else {
            @if (!isTableEmpty()) {
                <div
                        class="table-container"
                        infinite-scroll
                        [scrollWindow]="false"
                        [infiniteScrollDistance]="2"
                        (scrolled)="onScroll()"
                        (scrolledUp)="onScrolledUp()"
                >
                    <table
                            mat-table
                            [dataSource]="fileService.fileServiceRecords()"
                            multiTemplateDataRows
                            matSort
                            matSortDisableClear
                            [matSortDirection]="fileService.sortDirectionValues().direction"
                            [matSortActive]="fileService.sortDirectionValues().active"
                            (matSortChange)="changeFileServiceTableSortDirection($event)"
                    >
                        @for (column of fileService.displayedColumns(); track $index) {
                            <ng-container [matColumnDef]="column">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!!fileService.tuningDrilldown()">{{ column }}</th>
                                <td
                                        mat-cell
                                        *matCellDef="let element"
                                        [ngClass]="element.pureoriginalid ? 'green' : ''"
                                >
                                    {{ formatDate(element[column], column) | shorten : 10000 }}
                                </td>
                            </ng-container>
                        }

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                            <td
                                    mat-cell
                                    *matCellDef="let element"
                                    [ngClass]="element.pureoriginalid ? 'green' : 'white'"
                            >
                                <button
                                        *ngIf="element.aiStatus"
                                        class="table-buttons ai-button"
                                        [title]="'AI Finisher worked this import (' + element.aiStatus + ') — click for the suggestion, reason and approve/reject'"
                                        (click)="openAiWorkDialog(element)"
                                >
                                    <i class="bi bi-robot"></i>
                                </button>
                                <button
                                        *ngIf="element.pureoriginalid"
                                        class="table-buttons car-button"
                                        [disabled]="!element.pureoriginalid"
                                        (click)="openPureOriginalMatchingDetails(+element.pureoriginalid)"
                                >
                                    <i class="bi bi-car-front-fill"></i>
                                </button>
                                <button
                                        class="table-buttons"
                                        (click)="deleteItemFromTable(+element.importid, 'IMPORTS')"
                                >
                                    <i class="bi bi-trash"></i>
                                </button>
                                <button
                                        class="table-buttons"
                                        [disabled]="element.status.includes('Failed')"
                                        (click)="downloadFileFromTable(+element.importid, element.filename)"
                                >
                                    <i class="bi bi-file-earmark-arrow-down"></i>
                                </button>
                            </td>
                        </ng-container>

                        <tr
                                mat-header-row
                                *matHeaderRowDef="fileService.displayedTableHeaders()"
                        ></tr>
                        <tr
                                mat-row
                                *matRowDef="let element; columns: fileService.displayedTableHeaders()"
                        ></tr>
                    </table>
                </div>
            } @else {
                <div class="empty-table-wrapper">
                    <div class="empty-table">NO RESULTS</div>
                </div>
            }
        }
    }
</section>
